export class ChoixSupportMessages {

  public libelleChoix = 'choixSupport.libelleChoix';
  public filtreActifs = 'choixSupport.filtreActifs';
  public filtreDisponibles = 'choixSupport.filtreDisponibles';


  constructor() {
  }
}
